export default __webpack_public_path__ + "static/media/app_signup.650a6bde.png";